import { Element, Firm } from '../generated/graphql';
import { SCORECARD_ELEMENT_SYMBOLS } from './constants';
import { ScorecardElementSymbol } from './util';

type FirmCustomizationOwner = Pick<Firm, 'elementCustomizations'> | null | undefined;

const scorecardElementSymbolToElementMap: Partial<Record<ScorecardElementSymbol, Element>> = {
  Br: Element.Br,
  Bt: Element.Bt,
  Dr: Element.Dr,
  Er: Element.Er,
  Ir: Element.Ir,
  Es: Element.Es,
  Lt: Element.Lt,
  Qt: Element.Qt,
  Rt: Element.Rt,
  Sr: Element.Sr,
  Tr: Element.Tr,
  Tt: Element.Tt,
};

export function scorecardElementSymbolToElement(symbol: ScorecardElementSymbol): Element | undefined {
  return scorecardElementSymbolToElementMap[symbol];
}

export const CUSTOMIZABLE_SCORECARD_ELEMENT_SYMBOLS = SCORECARD_ELEMENT_SYMBOLS.filter(
  (symbol) => scorecardElementSymbolToElement(symbol) !== undefined
);

export function getFirmElementCustomization(
  firm: FirmCustomizationOwner,
  symbol: ScorecardElementSymbol
) {
  const element = scorecardElementSymbolToElement(symbol);
  if (!element) return undefined;

  return firm?.elementCustomizations?.find((customization) => customization.element === element);
}

export function resolveScorecardElementVisibility(args: {
  firm: FirmCustomizationOwner;
  symbol: ScorecardElementSymbol;
}) {
  return getFirmElementCustomization(args.firm, args.symbol)?.visibleByDefault ?? true;
}

export function getVisibleScorecardElementSymbols(args: {
  firm: FirmCustomizationOwner;
  symbols?: ScorecardElementSymbol[];
}) {
  return (args.symbols ?? SCORECARD_ELEMENT_SYMBOLS).filter((symbol) =>
    resolveScorecardElementVisibility({
      firm: args.firm,
      symbol,
    })
  );
}
